import type { Interpolation, Theme } from '@emotion/react';
import { standardSizes } from '@toilet-paper-games/ui';

export const insetVerticalScrollbar: Interpolation<Theme> = {
  '& > [data-orientation="vertical"]': {
    marginBlock: standardSizes.lg,
  },
};
